"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var highlight_1 = require("./highlight");
var typeahead_window_1 = require("./typeahead-window");
var typeahead_1 = require("./typeahead");
var typeahead_config_1 = require("./typeahead-config");
var live_1 = require("./../util/accessibility/live");
var highlight_2 = require("./highlight");
exports.NgbHighlight = highlight_2.NgbHighlight;
var typeahead_window_2 = require("./typeahead-window");
exports.NgbTypeaheadWindow = typeahead_window_2.NgbTypeaheadWindow;
var typeahead_config_2 = require("./typeahead-config");
exports.NgbTypeaheadConfig = typeahead_config_2.NgbTypeaheadConfig;
var typeahead_2 = require("./typeahead");
exports.NgbTypeahead = typeahead_2.NgbTypeahead;
var NgbTypeaheadModule = /** @class */ (function () {
    function NgbTypeaheadModule() {
    }
    NgbTypeaheadModule_1 = NgbTypeaheadModule;
    NgbTypeaheadModule.forRoot = function () {
        return {
            ngModule: NgbTypeaheadModule_1,
            providers: [live_1.Live, typeahead_config_1.NgbTypeaheadConfig, { provide: live_1.ARIA_LIVE_DELAY, useValue: live_1.DEFAULT_ARIA_LIVE_DELAY }]
        };
    };
    NgbTypeaheadModule = NgbTypeaheadModule_1 = __decorate([
        core_1.NgModule({
            declarations: [typeahead_1.NgbTypeahead, highlight_1.NgbHighlight, typeahead_window_1.NgbTypeaheadWindow],
            exports: [typeahead_1.NgbTypeahead, highlight_1.NgbHighlight],
            imports: [common_1.CommonModule],
            entryComponents: [typeahead_window_1.NgbTypeaheadWindow]
        })
    ], NgbTypeaheadModule);
    return NgbTypeaheadModule;
    var NgbTypeaheadModule_1;
}());
exports.NgbTypeaheadModule = NgbTypeaheadModule;
//# sourceMappingURL=typeahead.module.js.map


//////////////////
// WEBPACK FOOTER
// ./temp/typeahead/typeahead.module.js
// module id = 76
// module chunks = 0